import { fetchFromDashboardPublicApi, fetchOutsideAirthings } from 'commons/src/api/fetch';
import { FetchPublicDeviceDataType, FetchPublicDeviceResponse, FetchPublicRadonResponse } from '../actions/actions';
import { PublicDeviceResponse } from '../models/commons';

declare const fetch: (url: string) => Promise<Response>;

export const addQueryParams = (measurementSystem: string): string => `?measurementSystem=${measurementSystem}`;

export const getPublicDeviceData = async (payload: FetchPublicDeviceDataType): Promise<FetchPublicDeviceResponse> =>
    fetchFromDashboardPublicApi<FetchPublicDeviceResponse>(
        `/device/${payload.publicUrlPath}${addQueryParams(payload.measurementSystem)}`,
        {
            method: 'GET',
        }
    );

export const getPublicDeviceSensorData = async (
    payload: FetchPublicDeviceDataType
): Promise<{ data: PublicDeviceResponse }> =>
    fetchFromDashboardPublicApi<{ data: PublicDeviceResponse }>(
        `/device/${payload.publicUrlPath}/latest-samples${addQueryParams(payload.measurementSystem)}`,
        {
            method: 'GET',
        }
    );

export const fetchLogoImage = (bucketUrl: string): Promise<string> => fetch(bucketUrl).then(res => res.text());

// Used to fetch radondata from radonmap(currently not in use):
const radonBaseUrl = 'https://oj39d18xjl.execute-api.eu-west-1.amazonaws.com/prod/timeseriesdata';
export const getPublicRadonData = async (payload: { geoHash: string }): Promise<{ data: FetchPublicRadonResponse }> =>
    fetchOutsideAirthings<{ data: FetchPublicRadonResponse }>(`${radonBaseUrl}?geohash=${payload.geoHash}`, {
        method: 'GET',
    });
